export const inputCls =
  "w-full bg-transparent border border-white/20 px-3.5 py-2.5 text-sm text-white placeholder:text-neutral-600 focus:outline-none focus:border-white transition-colors duration-300";

export const Field = ({ label, id, children }) => (
  <div>
    <label htmlFor={id} className="block font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500 mb-1.5">
      {label}
    </label>
    {children}
  </div>
);

export const Btn = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 bg-white text-black font-mono text-[10px] uppercase tracking-[0.25em] px-5 py-3 hover:bg-neutral-300 disabled:opacity-50 transition-colors duration-300 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const GhostBtn = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 border border-white/20 font-mono text-[10px] uppercase tracking-[0.25em] px-4 py-2.5 text-neutral-300 hover:bg-white hover:text-black transition-colors duration-300 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const Th = ({ children, ...props }) => (
  <th className="text-left px-4 py-3 font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500 whitespace-nowrap" {...props}>
    {children}
  </th>
);

export const Td = ({ children, className = "", ...props }) => (
  <td className={`px-4 py-3.5 text-sm align-top ${className}`} {...props}>{children}</td>
);

export const TableWrap = ({ children, testid }) => (
  <div className="border border-white/10 overflow-x-auto" data-testid={testid}>
    <table className="w-full text-sm min-w-[760px]">{children}</table>
  </div>
);

export const EmptyRow = ({ cols, children }) => (
  <tr>
    <td colSpan={cols} className="px-4 py-10 text-center text-neutral-500 font-mono text-[10px] uppercase tracking-[0.25em]">
      {children}
    </td>
  </tr>
);
